// Full-screen upsell shown to org members whose trial ended (or whose
// subscription has otherwise lapsed) and who have not picked a paid plan.
//
// The route shell still mounts so /settings/billing and the other
// /settings/* pages remain reachable -- this component only takes over
// the module + dashboard surfaces. See App.tsx for the wiring.

import { Link } from 'react-router-dom';
import { Button, Card, Display, SmallCap } from '@pc/ui';
import { useOrgBilling } from './useOrgBilling';

export function TrialExpiredGate() {
  const billingQ = useOrgBilling();
  const sub = billingQ.data?.subscription ?? null;
  const planName = billingQ.data?.plan?.name ?? 'PeptideClients';
  const trialEnd = sub?.trial_end ? new Date(sub.trial_end) : null;

  const headline =
    sub?.status === 'trialing'
      ? 'Your free trial has ended.'
      : 'Your subscription is inactive.';

  return (
    <div className="max-w-2xl">
      <SmallCap>Workspace locked</SmallCap>
      <Display size="md" className="mt-2">
        {headline.split(' ').slice(0, -1).join(' ')}{' '}
        <em>{headline.split(' ').slice(-1)[0]}</em>
      </Display>

      <p className="mt-4 text-sm text-ink-2 max-w-prose">
        {trialEnd ? (
          <>
            Your {planName} trial ended on{' '}
            <span className="tabular">{trialEnd.toLocaleDateString()}</span>. Pick a plan to
            restore access for everyone in this workspace.
          </>
        ) : (
          <>
            Pick a plan to restore access for everyone in this workspace.
          </>
        )}
      </p>

      <Card className="mt-8" title="Resume your workspace">
        <div className="flex flex-col gap-3">
          <p className="text-sm text-ink-2 max-w-prose">
            Modules are paused until a plan is selected. Your data, clients, and orders are
            preserved exactly as you left them &mdash; the workspace will be back online the
            moment a plan is active.
          </p>
          <div className="flex gap-3">
            <Link to="/settings/billing">
              <Button>Choose a plan</Button>
            </Link>
            <Link to="/settings/account">
              <Button variant="ghost">Account settings</Button>
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
}
